<template>
  <div class="map1">
    <van-popup v-model="show" class="tishiTanchu">
      <div class="tishiContent">
        <div class="chaIcon" @click="noShowTishi">
          <img src="../assets/images/chaIcon.png" alt="" />
        </div>
        <div class="title">提示</div>
        <div class="secondWord">为保证定位的精确，务必开启</div>
        <div class="thirdWord">手机定位功能!</div>
        <div class="dibuBtn">
          <button @click="noShowTishi">好的，知道了</button>
        </div>
      </div>
    </van-popup>
    <div class="NewInputZu">
      <van-search
        v-model="addrNameLike"
        placeholder="搜索"
        @input="addrLike"
        class="NewInput"
        :clearable="false"
        id="tipInput"
      />
      <p @click="clearShiwuInput">取消</p>
    </div>
    <div id="allmap" v-show="isMapShow"></div>
    <div class="content1" v-show="isMapShow">
      <div class="addrList">
        <div
          class="inList"
          v-for="(item, index) in mapList"
          :key="index"
          @click="
            selAddr(
              item.title,
              item.address,

              item.point.lng,
              item.point.lat
            )
          "
        >
          <div class="addrName">{{ item.title }}</div>
          <div class="inaddr">{{ item.address }}</div>
        </div>
        <div class="wule">
          <div class="leftStyle">
            <div class="shadowLine left"></div>
          </div>
          <span> <img src="../assets/images/lines2.svg" alt="" /></span>
          <div class="centerWord">没有更多了</div>
          <span> <img src="../assets/images/lines2.svg" alt="" /></span>
          <div class="rightStyle">
            <div class="shadowLine right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="content2" v-show="isSearchListShow">
      <div class="addrList">
        <div
          class="inList"
          v-for="item in searchList"
          :key="item.id"
          @click="selSearchAddr(item.point.lng, item.point.lat)"
        >
          <div class="addrName">{{ item.title }}</div>
          <div class="inaddr">{{ item.address }}</div>
        </div>
        <div class="wule">
          <div class="leftStyle">
            <div class="shadowLine left"></div>
          </div>
          <span> <img src="../assets/images/lines2.svg" alt="" /></span>
          <div class="centerWord">没有更多了</div>
          <span> <img src="../assets/images/lines2.svg" alt="" /></span>
          <div class="rightStyle">
            <div class="shadowLine right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import { Dialog } from "vant";
import BMap from "BMap";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);

export default {
  beforeRouteLeave(to, from, next) {
    if (this.isClick == false) {
      to.query.content = from.query.content;
      to.query.fileurlList = from.query.fileurlList;
      to.query.fileList = from.query.fileList;
    }
    next();
  },
  data() {
    return {
      addrNameLike: "",
      isBottomTipShow: true,
      isBottomTipShow2: false,
      currentPage: 1,
      searchList: [],
      loading: false,
      finished: false,
      isMapShow: true,
      isSearchListShow: false,
      mapList: [],

      selAddress: false,
      current: -1,
      addrName: "",
      inAddr: "",
      lng: "",
      lat: "",
      show: false,
      centerLng: null,
      centerLat: null,
      isClick: false,
    };
  },
  mounted() {
    this.getLocation();

    this.getHeight2();
    this.getHeight();
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto;");
  },
  methods: {
    noShowTishi() {
      this.show = false;
    },

    getLocation() {
      let that = this;
      var geolocation = new BMap.Geolocation();
      // 开启辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(
        function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            (that.centerLng = r.point.lng), (that.centerLat = r.point.lat);
            console.log(r.point.lng, r.point.lat);
            that.initMap();

            that.show = true;
          } else {
            Dialog.alert({
              message: "为了给您推荐附近的网点，请开启手机定位服务！",
            }).then(() => {});
          }
        },
        { enableHighAccuracy: true }
      );
    },

    selAddr(name, address, lng, lat) {
      this.addrName = name;
      this.inAddr = address;
      this.lng = lng;
      this.lat = lat;
      this.isClick = true;
      this.$router.push({
        name: "Fabu",
        query: {
          address: this.inAddr,
          lng: this.lng,
          lat: this.lat,
          afterAddr: true,
          content: this.$route.query.content,
          current: this.$route.query.current,
          fileurlList: this.$route.query.fileurlList,
          fileList: this.$route.query.fileList,
        },
      });
    },
    selSearchAddr(lng, lat) {
      this.addrNameLike = "";
      this.centerLng = lng;
      this.centerLat = lat;
      this.isSearchListShow = false;
      this.isMapShow = true;
      this.initMap();
    },
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".content2").offsetTop -
        document.documentElement.scrollTop;

      document.querySelector(".content2").style.height = a - b + "px";
    },
    getHeight2() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".content1").offsetTop -
        document.documentElement.scrollTop;

      document.querySelector(".content1").style.height = a - b + "px";
    },
    mapSearch() {
      this.searchList = [];

      let that = this;
      var map = new BMap.Map("allmap");
      map.centerAndZoom(new BMap.Point(that.centerLng, that.centerLat), 14);

      var options = {
        pageCapacity: 30,
        onSearchComplete: function (results) {
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            // 判断状态是否正确
            console.log(results);
            that.searchList = results.Ir;
          }
        },
      };
      var local = new BMap.LocalSearch(map, options);
      local.search(this.addrNameLike);
    },
    initMap() {
      this.mapList = [];
      let that = this;
      var map = new BMap.Map("allmap"); // 创建Map实例
      var mPoint = new BMap.Point(that.centerLng, that.centerLat);
      map.centerAndZoom(mPoint, 14); // 初始化地图,设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var marker = new BMap.Marker(
        new BMap.Point(that.centerLng, that.centerLat)
      );
      map.addOverlay(marker);
      setTimeout(function () {
        map.panTo(mPoint);
      }, 200);
      // map.panTo(mPoint);
      var circle = new BMap.Circle(mPoint, 1000, {
        fillColor: "blue",
        strokeWeight: 1,
        fillOpacity: 0.3,
        strokeOpacity: 0.3,
      });
      map.addOverlay(circle);
      var mOption = {
        poiRadius: 1000, //半径为1000米内的POI,默认100米
        numPois: 15, //列举出50个POI,默认10个
      };

      var myGeo = new BMap.Geocoder();

      myGeo.getLocation(
        mPoint,
        function mCallback(rs) {
          var allPois = rs.surroundingPois; //获取全部POI（该点半径为100米内有6个POI点）
          console.log(allPois);
          that.mapList = allPois;
        },
        mOption
      );

      marker.enableDragging(); //启用拖拽
      marker.addEventListener("dragend", function (e) {
        console.log(e);
        that.centerLng = e.point.lng;
        that.centerLat = e.point.lat;
        that.initMap();
      });
    },

    addrLike() {
      this.searchList = [];

      this.isMapShow = false;
      this.isSearchListShow = true;
      this.mapSearch();
    },
    clearShiwuInput() {
      this.addrNameLike = "";
      this.isSearchListShow = false;
      this.currentPage = 1;
      this.finished = false;
      this.isMapShow = true;
      this.initMap();
    },
  },
};
</script>

<style lang="scss" scoped>
.map1 {
  background-color: #fff;
}
.content2 {
  border-top: 1px solid #eee;
  margin-top: 1.25rem;
  overflow: auto;
  margin-bottom: 9.375rem;
  .addrList {
    padding: 0 2rem 20rem 2rem;
    .inList {
      padding: 1.25rem 0;
      border-bottom: 1px solid #eee;
      position: relative;
      .addrName {
        color: #383838;
        font-size: 1.875rem;
      }
      .inaddr {
        color: #878787;
        font-size: 1.625rem;
        margin-top: 0.625rem;
      }
      .sel {
        img {
          width: 1.875rem;
        }
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
}

#allmap {
  width: 100%;
  margin-top: 1.25rem;
  height: 37.5rem;
}
.content1 {
  overflow: auto;
  padding-bottom: 7.5rem;
  margin-bottom: 9.375rem;
  .addrList {
    padding: 0 2rem 4rem 2rem;
    .inList {
      padding: 1.25rem 0;
      border-bottom: 1px solid #eee;
      position: relative;
      .addrName {
        color: #383838;
        font-size: 1.875rem;
      }
      .inaddr {
        color: #878787;
        font-size: 1.625rem;
        margin-top: 0.625rem;
      }
      .sel {
        img {
          width: 1.875rem;
        }
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
}

.NewInputZu {
  display: flex;
  align-items: center;
  padding-top: 1.875rem;
  padding-left: 2.125rem;
  p {
    font-size: 1.75rem;
    color: #338989;
    margin-left: 1.75rem;
  }
}
.NewInputZu ::v-deep .NewInput {
  width: 36.625rem;
  height: 5rem;
  background: #f9f9f9;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #f9f9f9;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}
.wule {
  width: 100%;
  padding: 0 2rem;
  margin-top: 2.625rem;
  margin-bottom: 3.125rem;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .centerWord {
    white-space: nowrap;
    font-size: 1.875rem;
    color: #979494;
  }

  .leftStyle {
    display: flex;

    .shadowLine {
      width: 12.5rem;
      height: 0.5rem;
      background: linear-gradient(
        89.96deg,
        rgba(251, 249, 240, 0) -21.62%,
        #bcbcbc 73.74%
      );
      opacity: 0.3;
      border-radius: 0.75rem;
    }
  }

  .rightStyle {
    display: flex;

    .shadowLine {
      width: 12.5rem;
      height: 0.5rem;
      background: linear-gradient(
        89.96deg,
        rgba(251, 249, 240, 0) -21.62%,
        #bcbcbc 73.74%
      );
      opacity: 0.3;
      border-radius: 0.75rem;
      transform: matrix(-1, 0, 0, 1, 0, 0);
    }
  }
}
.dibubtn {
  width: 100%;
  background-color: #eef4f6;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  padding: 0 2rem 0 2rem;

  button {
    width: 100%;
    height: 5.5rem;
    background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
    border: none;
    color: #ffffff;
    font-size: 2rem;
    border-radius: 2.75rem;
    line-height: 5.5rem;
  }
}
.tishiTanchu {
  width: 90%;
  border-radius: 1.875rem;
  .tishiContent {
    position: relative;
    padding: 2.375rem 2.625rem 3.375rem 2.625rem;
    .chaIcon {
      position: absolute;
      right: 2.625rem;
      top: 2.625rem;
      img {
        width: 1.625rem;
        height: 1.625rem;
      }
    }
    .title {
      text-align: center;
      color: #338989;
      font-size: 2.5rem;
      font-weight: 900;
      line-height: 3.625rem;
    }
    .secondWord {
      text-align: center;
      color: #19212a;
      font-size: 2rem;
      line-height: 3.5rem;
      margin-top: 3rem;
    }
    .thirdWord {
      text-align: center;
      color: #19212a;
      font-size: 2rem;
      line-height: 3.5rem;
    }
    .dibuBtn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2.375rem;
      button {
        padding: 1.125rem 6.125rem;
        white-space: nowrap;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        color: #ffffff;
        font-size: 2rem;
        line-height: 2.875rem;
        border: none;
        border-radius: 2.5rem;
        font-weight: 900;
      }
    }
  }
}
</style>